import { CreditCard, AlertTriangle, Clock, CheckCircle } from "lucide-react";

function formatValue(v) {
  if (v == null || v === 0) return "R$ 0";
  if (v >= 1000) return "R$ " + (v / 1000).toFixed(1) + "k";
  return "R$ " + v.toFixed(0);
}

var STATUS_LABELS = { pending: "Pendente", paid: "Pago", overdue: "Vencido", cancelled: "Cancelado" };
var STATUS_ICONS = { pending: Clock, paid: CheckCircle, overdue: AlertTriangle, cancelled: AlertTriangle };
var STATUS_CLS = {
  pending: "bg-amber-50 border-amber-200 text-amber-700",
  paid: "bg-emerald-50 border-emerald-200 text-emerald-700",
  overdue: "bg-red-50 border-red-200 text-red-700",
  cancelled: "bg-gray-50 border-gray-200 text-gray-700",
};

export default function PaymentsReport({ data }) {
  if (!data) return null;

  return (
    <div data-testid="payments-report">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-red-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 bg-red-50 rounded-lg"><AlertTriangle className="w-4 h-4 text-red-500" /></div>
            <span className="text-xs text-gray-500">Vencidos</span>
          </div>
          <p className="text-xl font-bold text-red-600" data-testid="pay-overdue-count">{data.overdue.count}</p>
          <p className="text-xs text-red-400">{formatValue(data.overdue.total)}</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-amber-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 bg-amber-50 rounded-lg"><Clock className="w-4 h-4 text-amber-500" /></div>
            <span className="text-xs text-gray-500">Proximos 30 dias</span>
          </div>
          <p className="text-xl font-bold text-amber-600" data-testid="pay-upcoming-count">{data.upcoming_30_days.count}</p>
          <p className="text-xs text-amber-400">{formatValue(data.upcoming_30_days.total)}</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-emerald-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 bg-emerald-50 rounded-lg"><CheckCircle className="w-4 h-4 text-emerald-500" /></div>
            <span className="text-xs text-gray-500">Pagos</span>
          </div>
          {(function() {
            var paid = (data.by_status || []).find(function(s) { return s.status === "paid"; });
            return (
              <div>
                <p className="text-xl font-bold text-emerald-600" data-testid="pay-paid-count">{paid ? paid.count : 0}</p>
                <p className="text-xs text-emerald-400">{formatValue(paid ? paid.total : 0)}</p>
              </div>
            );
          })()}
        </div>
      </div>

      <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
        <h4 className="text-sm font-semibold text-[#0A2F3D] mb-4">Detalhamento por Status</h4>
        <div className="space-y-3">
          {(data.by_status || []).map(function(s) {
            var Icon = STATUS_ICONS[s.status] || CreditCard;
            var cls = STATUS_CLS[s.status] || "bg-gray-50 border-gray-200 text-gray-700";
            return (
              <div key={s.status} className={"flex items-center justify-between p-3 rounded-lg border " + cls}>
                <div className="flex items-center gap-2">
                  <Icon className="w-4 h-4" />
                  <span className="text-sm font-medium">{STATUS_LABELS[s.status] || s.status}</span>
                </div>
                <div className="text-right">
                  <span className="text-sm font-bold">{formatValue(s.total)}</span>
                  <span className="text-xs text-gray-500 ml-2">({s.count})</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
